import { DiscountType } from "services/api/settings";

interface BillingLine {
  quantity: number | null;
  priceWithoutTax: number | null;
  taxRate: number | null;
  discountTypeId: string | null;
  discountAmount: number | null;
}

/**
 * Osnovica stavke — nakon popusta, prije PDV-a. Popust ide PRIJE PDV-a, isto pravilo koristi
 * poslužitelj (`BillingTotalsCalculator`), PDF i UBL, pa se iznosi ne razilaze.
 */
export const calculateBillingLineNet = (line: BillingLine): number => {
  const { quantity, priceWithoutTax, discountTypeId, discountAmount } = line;

  if (!quantity || !priceWithoutTax) return 0;

  const base = quantity * priceWithoutTax;

  let net = base;

  if (discountAmount && discountAmount > 0) {
    if (discountTypeId === DiscountType.PERCENTAGE.key) net = base * (1 - discountAmount / 100);
    if (discountTypeId === DiscountType.AMOUNT.key) net = base - discountAmount;
  }

  return Math.max(0, Number(net.toFixed(2)));
};

/** Iznos stavke s PDV-om. */
export const calculateBillingLineTotal = (line: BillingLine): number => {
  const { taxRate } = line;

  if (taxRate === null || taxRate === undefined) return 0;

  const net = calculateBillingLineNet(line);

  return Math.max(0, Number((net * (1 + Number(taxRate) / 100)).toFixed(2)));
};
